var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Collapse } from "@mui/material";
import { useCallback, useEffect } from "react";
import { COLORS } from "../../../../../constants";
import { TextField } from "../../../../Atoms";
import { ActionIcon } from "../../Atoms";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useSearchContext } from "../../searchContext";
var SearchBar = function (_a) {
    var searchTerm = _a.searchTerm, clearSearch = _a.clearSearch, updateSearch = _a.updateSearch, isLargeToolbar = _a.isLargeToolbar, name = _a.name, placeholder = _a.placeholder;
    var _b = useSearchContext(), setSearchOpen = _b.setSearchOpen, searchOpen = _b.searchOpen;
    useEffect(function () {
        if (!!searchTerm) {
            setSearchOpen(true);
        }
    }, []);
    var closeSearch = useCallback(function () {
        clearSearch();
        setSearchOpen(false);
    }, [clearSearch]);
    var openSearchBar = useCallback(function () {
        setSearchOpen(true);
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(Collapse, __assign({ in: searchOpen, timeout: "auto", "data-testid": "collapse-search-bar", orientation: "horizontal" }, { children: _jsx(TextField, { sx: {
                        width: isLargeToolbar ? "240px" : "179px",
                        mr: isLargeToolbar ? 2 : 0,
                        ".MuiOutlinedInput-root": {
                            bgcolor: COLORS.WHITE,
                            pr: 0.5,
                        },
                    }, inputSize: "small", id: "search-".concat(name), name: name, value: searchTerm, endAdornmentClick: closeSearch, endAdornment: _jsx(CloseIcon, { fontSize: "small" }), onChange: updateSearch, variant: "outlined", placeholder: placeholder }) })), _jsx(Collapse, __assign({ in: !searchOpen, timeout: "auto", "data-testid": "collapse-search-icon", orientation: "horizontal", sx: {
                    display: !searchOpen ? "block" : "none",
                } }, { children: _jsx(ActionIcon, __assign({ "data-testid": "toolbar-search-icon", active: true, action: openSearchBar }, { children: _jsx(SearchIcon, {}) })) }))] }));
};
export default SearchBar;
